module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"frontmatter":{"username":"ekug","fullname":"Ekansh Gupta"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/submissions.json
// module id = 329
// module chunks = 236347314162643